export const propPoliciesRoomsHc = {
  policies: {
    breadcrumb: `Politique de confidentialité`,
    cloneTitleNoun: `politiques de l'hébergement`,
    cloneItemNoun: `les politiques`,
    editorHintLang: `Politique de confidentialité en {label}`,
    optional: `(facultatif)`,
    headingOpt1: `Titre 1`,
    headingOpt2: `Titre 2`,
    headingOpt3: `Titre 3`,
    headingNormal: `Normal`,
    tipBold: `Gras`,
    tipItalic: `Italique`,
    tipUnderline: `Souligné`,
    tipListOrdered: `Liste ordonnée`,
    tipListBullet: `Liste à puces`,
    tipLink: `Lien`,
    tipQuote: `Citation`,
    tipClean: `Effacer la mise en forme`,
    charCount: `{count} caractère | {count} caractères`,
    saving: `Enregistrement…`,
    editorPlaceholder: `Rédigez ici la politique de confidentialité en {label}…`,
    errNoListing: `Annonce introuvable.`,
    errLoad: `Impossible de charger la politique de confidentialité.`,
    errEsRequired: `La politique en espagnol est obligatoire.`,
    saveSuccess: `Politique de confidentialité enregistrée avec succès.`,
    saveError: `Erreur lors de l'enregistrement des politiques.`,
  },
  rooms: {
    bulkTitle: `Créer des chambres en lot`,
    bulkSubtitle: `Générez plusieurs chambres pour un type, avec un code automatique et une description facultative.`,
    available: `Disponibles : {count}`,
    willCreate: `À créer : {count}`,
    needTypeFirst: `Créez d'abord au moins un <b>Type de chambre</b> afin de pouvoir générer des chambres.`,
    labelType: `Type`,
    selectType: `Sélectionnez un type`,
    labelQuantity: `Quantité`,
    phQuantity: `Ex. : 10`,
    labelPrefix: `Préfixe du code`,
    phPrefix: `Ex. : A- ou 10`,
    optional: `Facultatif`,
    labelStart: `Début`,
    labelPadding: `Remplissage`,
    labelDescription: `Description (facultatif)`,
    phDescription: `Elle sera appliquée aux chambres créées`,
    nameEqType: `Nom = Type`,
    recommended: `(recommandé)`,
    example: `Exemple :`,
    createBulk: `Créer en lot`,
    typeFallback: `Type`,
    previewFormat: `{name} • Code : {code}`,
    noActivePlan: `Vous n'avez pas de forfait actif pour créer des chambres.`,
    limitReached: `Limite atteinte : votre forfait autorise {limit} chambres pour cette propriété.`,
    selectTypeWarn: `Sélectionnez un type de chambre.`,
    invalidQuantity: `Indiquez une quantité valide.`,
    cannotAddMore: `Vous ne pouvez pas en ajouter davantage. Limite : {limit}.`,
    partialCreated: `Seules {created} ont été créées car votre forfait autorise {limit} et il vous en restait {remaining}.`,
    planLimitSave: `Votre forfait autorise {limit} chambres. Vous essayez d'en enregistrer {count}.`,
  },
  images: {
    zipDownloadTitle: `Téléchargez toutes les images de la propriété dans un ZIP`,
    zipNoImages: `Aucune image à télécharger`,
    preparing: `Préparation…`,
    downloadImages: `Télécharger les images`,
    loading: `Chargement des images…`,
    noAccommodations: `Aucun hébergement n'est encore configuré pour cette propriété.`,
    engineCoverTag: `Couverture du moteur`,
    imageCount: `{count} image | {count} images`,
    hotelPhotosDesc: `Photos générales (cour, entrée, réception…) que le client verra en ouvrant le moteur`,
    dragToOrder: `Faites glisser pour ordonner la galerie`,
    ordering: `Tri en cours…`,
    dragTip: `Faire glisser`,
    hotelSectionName: `Photos de l'hôtel · espaces communs`,
    orderUpdated: `Ordre des images mis à jour.`,
    orderError: `Impossible de mettre à jour l'ordre des images.`,
    downloadError: `Impossible de télécharger les images.`,
  },
};
